(function(){
  const root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') || '/';
  const fmt  = new Intl.NumberFormat('es-MX',{ style:'currency', currency:'MXN' });

  // ====== Estado global ======
  let currentQuery = '';
  let activeForm   = null;
  let items        = [];
  let idx          = -1;

  // ====== Utils ======
  const norm = s => (s||'').toString().normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const debounce = (fn, d=220) => {
    let t; return (...a)=>{ clearTimeout(t); t = setTimeout(()=>fn(...a), d); };
  };

  function selInForm(form, sel){
    return form.querySelector(sel) || form.querySelector(sel.replace('#',' .').replace('.',' '));
  }

  function getFormFrom(el){
    return el?.closest?.('.fm-form') || el?.closest?.('#fm-form') || null;
  }

  function closePanel(form){
    const panel = selInForm(form, '#fm-panel') || selInForm(form, '.fm-panel');
    const list  = selInForm(form, '#fm-list')  || selInForm(form, '.fm-list');
    if (panel) panel.hidden = true;
    if (list)  list.innerHTML = '';
    items = []; idx = -1;
  }

  function openPanel(form){
    const panel = selInForm(form, '#fm-panel') || selInForm(form, '.fm-panel');
    if (panel) panel.hidden = false;
  }

  function setActive(){
    items.forEach((a,i)=>a.setAttribute('aria-selected', i===idx?'true':'false'));
    if (idx>=0 && items[idx]) items[idx].scrollIntoView({block:'nearest'});
  }

  // ====== Fetch predictivo ======
  async function fetchPredictive(q){
    const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last`;
    const r = await fetch(url,{headers:{'Accept':'application/json'}});
    if (!r.ok) throw new Error('Suggest failed');
    const data = await r.json();

    let products    = (data?.resources?.results?.products)    || [];
    let collections = (data?.resources?.results?.collections) || [];

    // Filtro estricto
    const nq = norm(q);
    const strictMatch = (obj) => {
      const title  = norm(obj.title);
      const handle = norm(obj.handle||'');
      const body   = norm(obj.body||'');
      const sku    = norm((obj?.variants?.[0]?.sku) || '');
      return title.includes(nq) || handle.includes(nq) || body.includes(nq) || sku.includes(nq);
    };
    products    = products.filter(strictMatch);
    collections = collections.filter(strictMatch);

    // Normalizar datos mínimos
    products = products.map(p=>{
      let handle = p.handle;
      if (!handle && p.url){
        const m = p.url.match(/\/products\/([^/?#]+)/i);
        if (m) handle = m[1];
      }
      const image = (p.images && p.images[0]) ? (p.images[0].url || p.images[0]) : (p.featured_image?.url || p.featured_image) || '';
      return { title: p.title, handle, product_type: p.product_type, url: p.url || (handle? `${root}products/${handle}` : '#'), image };
    });

    collections = collections.map(c=>{
      const image = (c.image && (c.image.url || c.image)) || '';
      return { title: c.title, handle: c.handle, url: c.url || (c.handle? `${root}collections/${c.handle}` : '#'), image };
    });

    const types = Array.from(new Set(products.map(p=>p.product_type).filter(Boolean))).slice(0,8);
    return { products, collections, types };
  }

  // ====== Precios con cache ======
  const priceCache = new Map();

  async function fetchPrice(handle){
    if(!handle) return null;
    if(priceCache.has(handle)) return priceCache.get(handle);
    const r = await fetch(`${root}products/${handle}.js`, { headers:{ 'Accept':'application/json' }});
    if (!r.ok) return null;
    const p = await r.json();
    let price   = p?.variants?.length ? Math.min(...p.variants.map(v=>+v.price||Infinity)) : (+p?.variants?.[0]?.price||null);
    let compare = null;
    if (p?.variants?.length){
      const comps = p.variants.map(v=>+v.compare_at_price||0).filter(Boolean);
      compare = comps.length ? Math.min(...comps) : null;
    }
    const data = { price, compare_at_price: compare };
    priceCache.set(handle, data);
    return data;
  }

  async function enrichPrices(form, products){
    const isMobile = matchMedia('(max-width: 767px)').matches;
    if (isMobile) return; // 🔹 Optimización: no cargar precios en móviles

    const list = selInForm(form, '#fm-list') || selInForm(form, '.fm-list');
    if (!list) return;

    const slice = products.slice(0, 8);
    const priced=await Promise.all(slice.map(async(p)=>({ ...(p||{}), ...(await fetchPrice(p.handle) || {}) })));

    let iDom=0;
    const nodes=Array.from(list.querySelectorAll('.fm-item')).filter(n=>!n.classList.contains('fm-col-item'));
    priced.forEach((d)=>{
      const node=nodes[iDom++]; if(!node) return;
      const box=node.querySelector('.fm-price'); if(!box) return;
      box.innerHTML='';
      const hasCompare = d?.compare_at_price && +d.compare_at_price > +d.price||0;
      if(hasCompare){ const s=document.createElement('s'); s.textContent=fmt.format(+d.compare_at_price/100); box.appendChild(s); }
      const strong=document.createElement('strong'); strong.textContent = d?.price ? fmt.format(+d.price/100) : '—';
      box.appendChild(strong);
    });
  }

  // ====== Render ======
  function renderSections(form, data, q){
    const list   = selInForm(form, '#fm-list')  || selInForm(form, '.fm-list');
    const viewAll= selInForm(form, '#fm-all')   || selInForm(form, '.fm-all');
    if (!list || !viewAll) return;

    list.innerHTML=''; items=[];

    // Productos
    if(data.products.length){
      const h=document.createElement('div'); h.className='fm-sect-head'; h.textContent='Productos'; list.appendChild(h);
      data.products.forEach(d=>{
        const a=document.createElement('a'); a.className='fm-item'; a.href=d.url; a.setAttribute('role','option'); a.setAttribute('aria-selected','false');
        if(d.image){ const img=document.createElement('img'); img.className='fm-thumb'; img.alt=d.title||'Producto'; img.loading='lazy'; img.src=d.image; a.appendChild(img); }
        else { a.classList.add('no-thumb'); }
        const title=document.createElement('div'); title.className='fm-title'; title.textContent=d.title||'Producto';
        const price=document.createElement('div'); price.className='fm-price'; price.textContent='…';
        a.appendChild(title); a.appendChild(price);
        list.appendChild(a); items.push(a);
      });
    }

    // Colecciones
    if(data.collections.length){
      const h=document.createElement('div'); h.className='fm-sect-head'; h.textContent='Colecciones'; list.appendChild(h);
      data.collections.forEach(c=>{
        const a=document.createElement('a'); a.className='fm-item fm-col-item'; a.href=c.url; a.setAttribute('role','option'); a.setAttribute('aria-selected','false');
        if(c.image){ const img=document.createElement('img'); img.className='fm-thumb'; img.alt=c.title||'Colección'; img.loading='lazy'; img.src=c.image; a.appendChild(img); }
        else { a.classList.add('no-thumb'); }
        const title=document.createElement('div'); title.className='fm-title'; title.textContent=c.title||'Colección';
        a.appendChild(title);
        list.appendChild(a); items.push(a);
      });
    }

    // Tipos
    if(data.types.length){
      const h=document.createElement('div'); h.className='fm-sect-head'; h.textContent='Tipos de producto'; list.appendChild(h);
      const wrap=document.createElement('div'); wrap.className='fm-types';
      data.types.forEach(tp=>{
        const a=document.createElement('a'); a.className='fm-type-pill'; a.href=`${root}search?q=product_type:${encodeURIComponent('"' + tp + '"')}`; a.textContent=tp; wrap.appendChild(a);
      });
      list.appendChild(wrap);
    }

    viewAll.href = `${root}search?q=${encodeURIComponent(q)}`;
    openPanel(form);
  }

  // ====== Lógica de búsqueda global ======
  const doSearch = debounce(async (inputEl) => {
    if (!inputEl) return;
    const form = getFormFrom(inputEl);
    if (!form) return;

    const q = inputEl.value.trim();
    currentQuery = q;
    if(q.length < 2){ closePanel(form); return; }

    activeForm = form;
    try{
      const data = await fetchPredictive(q);
      if (activeForm !== form) return;
      if (q !== (form.querySelector('.fm-input')?.value || '').trim()) return;
      if(!(data.products.length || data.collections.length || data.types.length)){
        closePanel(form); return;
      }
      renderSections(form, data, q);
      enrichPrices(form, data.products).catch(()=>{});
    }catch(e){
      console.warn(e);
      closePanel(form);
    }
  }, 220);

  // ====== Delegación global ======
  document.addEventListener('input', (e)=>{
    if (e.target && e.target.matches('.fm-input')) {
      doSearch(e.target);
    }
  }, true);

  // Restaurar query previa si header se recrea
  document.addEventListener('focusin', (e)=>{
    if (e.target && e.target.matches('.fm-input')) {
      const el = e.target;
      if (!el.value && currentQuery && currentQuery.length>=2) {
        el.value = currentQuery;
        doSearch(el);
      }
    }
  }, true);

  // Navegación con teclado
  document.addEventListener('keydown', (e)=>{
    if (!activeForm) return;
    const panel = selInForm(activeForm, '#fm-panel') || selInForm(activeForm, '.fm-panel');
    if (!panel || panel.hidden) return;
    if (['ArrowDown','ArrowUp','Enter','Escape'].includes(e.key)){
      const max = items.length - 1;
      if(e.key==='ArrowDown'){ e.preventDefault(); idx=Math.min(max, idx+1); setActive(); }
      else if(e.key==='ArrowUp'){ e.preventDefault(); idx=Math.max(-1, idx-1); setActive(); }
      else if(e.key==='Enter'){ if(idx>=0 && items[idx]){ e.preventDefault(); window.location.href=items[idx].href; } }
      else if(e.key==='Escape'){ closePanel(activeForm); }
    }
  }, true);

  // Cierra panel al hacer click fuera
  document.addEventListener('click', (e)=>{
    const form = getFormFrom(e.target);
    if (!form && activeForm) {
      closePanel(activeForm);
      activeForm = null;
    }
  }, true);

  // Cierra panel al enviar form
  document.addEventListener('submit', (e)=>{
    if (e.target && e.target.matches('.fm-form,#fm-form')) {
      closePanel(e.target);
    }
  }, true);

})();